import { useEffect, useState } from 'react';
import { Col, Form, Row, Table } from 'react-bootstrap';
import { ArrowRight } from 'react-bootstrap-icons';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getDateNumber, renderDateNumber } from '../../app/dates';
import { AppDispatch, RootState } from '../../app/store';
import LoadingIndicator from '../loading/LoadingIndicator';
import { useAuth } from '../signin/auth';
import { listGoals, selectAllGoals, selectGoalsForDate } from './goalsSlice';
import { Goal } from './types';

function ListGoals() {
  const auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  const [forDate, setForDate] = useState(true);
  const goals = useSelector((state: RootState) => forDate ? selectGoalsForDate(state, getDateNumber()) : selectAllGoals(state));
  const goalsStatus = useSelector((state: RootState) => state.goals.status)
  const goalsError = useSelector((state: RootState) => state.goals.error)

  const toggleForDate = () => {
    setForDate(!forDate);
  };

  useEffect(() => {
    if (auth.authToken) {
      dispatch(listGoals({ authToken: auth.authToken }));
    }
  }, [dispatch, auth.authToken]);

  const renderGoalRow = (goal: Goal) => {
    return (
      <tr key={goal.id}>
        <td>
          <Link to={`/goal/${goal.id}`}>{goal.name}</Link>
        </td>
        <td>
          {renderDateNumber(goal.startDate)}
          &nbsp;<ArrowRight />&nbsp;
          {renderDateNumber(goal.endDate)}
        </td>
        <td>
          <Link to={`/goal/${goal.id}/edit`}>Edit</Link>
        </td>
      </tr>
    );
  };

  const renderGoals = () => {
    let content
    if (goals.length > 0) {
      content = goals.map((goal: Goal) => renderGoalRow(goal));
    }
    return content;
  };

  return (
    <div>
      {goalsStatus === 'loading' && <LoadingIndicator />}
      {goalsStatus === 'failed' && <div>{goalsError}</div>}
      <>
        <Row>
          <Col sm="auto">
            <Form.Check id="filter-to-current" checked={forDate} onChange={toggleForDate} label="Show current goals only?" />
          </Col>
        </Row>
        {goals.length > 0 && (
          <Row className="mt-3">
            <Col>
              <Table striped>
                <thead>
                  <tr>
                    <th>Goal</th>
                    <th>Dates</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {renderGoals()}
                </tbody>
              </Table>
            </Col>
          </Row>
        )}
      </>
    </div>
  );
}

export default ListGoals;